<template>
<div class='table-content'>
   <div class="title">填充客户数据</div>
   <div class="table-box">
    <Table @on-row-click="selectData" :columns="columns" :data="data">
      <template slot-scope="{row}" slot="idType">
        <div>
          {{row.idType|filterTable}}
        </div>
      </template>
    </Table>
   </div>
</div>
</template>
<script>
export default {
props:{
  data:Array,
},
data:()=>({
  columns:[
    {
      title: '姓名',
      key: 'name',
      width: 100,
      align:'center',
    },
    {
      title: '电话号码',
      key: 'mobile',
      align:'center',
      width: 140,
    },
    {
      title: '证件类型',
      key: 'idType',
      slot:'idType',
      align:'center',
      width: 100,
    },
    {
      title: '证件号码',
      key: 'cardNo3',
      align:'center',
      width: 200,
    },
    
  ],
}),
  components:{
  },
  created(){
    
  },
  methods:{
    selectData(row){
      this.$http({
        url: '/buz/customerBase/queryPolicyCustomerById',
        type: 'get',
        data: {
          id: row.id,
        },
      }).then((res) => {
        this.$emit('rePolicyInfo',res.data)
      })
    }
  },
  filters:{
    filterTable(val){
      if(!val){
        return 
      }else if(val=='1'){
        return "身份证"
      }else if(val=="2"){
        return '护照'
      }else if(val=="3"){
        return "军人证"
      }else if(val=="4"){
        return '其他'
      }else if(val=='5'){
        return '户口本'
      }else if(val=='6'){
        return '出生证'
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.table-content{
  .table-box{
    text-align: center;
    max-height: 300px;
    overflow-y: scroll;
  }
  .title{
    font-size: 16px;
    color: #3c464f;
    margin-bottom: 10px;
  }
}
</style>
